import { ReactNode } from 'react';
import { Flex, Text, Icon } from '@chakra-ui/react';
import { BsArrowRight } from 'react-icons/bs';
import { CustomNavLink } from './CustomNavLink';

export const LinkWithArrow = ({ children, ...restProps }: { children?: ReactNode; [key: string]: any }) => {
  return (
    <CustomNavLink
      color='brand.cyan'
      variant='default'
      _hover={{ textDecoration: 'none', opacity: '.8' }}
      {...restProps}
    >
      <Flex alignItems='center' fontWeight='500'>
        <Text mr={2}>{children}</Text>
        <Icon as={BsArrowRight} mt={1} />
      </Flex>
    </CustomNavLink>
  );
};
